<template lang="pug">
.tree
  li.item(v-if="model.children")
    div(:class="{bold: isFolder && open}")
      i.fa.fa-folder-o(v-if="isFolder && !open" @click="toggle(model)")
      i.fa.fa-folder-open-o(:class="{bold: isFolder && open}"  v-if="isFolder && open" @click="toggle(model)")
      i.fa.fa-location-arrow(v-if="!isFolder")
      span.hoverable(@click="select(model)") {{model.name}}
    ul(v-show="open" v-if="isFolder")
      i.fa.fa-spinner(v-if="isLoading") Loading... &nbsp;
      Tree.item(v-for="model in model.children" :model="model" :key="model.id")
  ul(v-else)
    Tree.item(v-for="model in model" :model="model" :key="model.id")
</template>

<script>

export default {
  name: 'Tree',
  props: ['model'],
  data: () => ({
    open: false
  }),
  computed: {
    isLoading() {
      return this.model.isLoading
    },
    isFolder() {
      return this.model.children && this.model.expander
    }
  },
  methods: {
    toggle(m) {
      if (this.isFolder) {
        if (m.expander && !this.open) {
          m.expander()
        }
        this.open = !this.open
      }
    },
    select(m) {
      m.select()
    }
  }
}
</script>

<style lang="scss">
.tree {
  .item {
    cursor: pointer;
  }
  .item {
    .selected {
      font-weight: bolder;
    }
    .hoverable {
      margin-left: 5px;
    }
    .hoverable:hover {
      font-weight: bold;
    }
  }
  ul {
    padding-left: 1em;
    line-height: 1.5em;
    list-style-type: dot;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Tree.vue